
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select'
import swal from 'sweetalert';
import moment from 'moment';
import { countryId } from '../../config/Constant';

import {
    getCountries, getCities, getSchools, getClasses, getCourses,
     getCountryCode, getStudyCenter, registerUser,
} from '../../actions/RegisterActions'
import { salesforceSendFormNumber } from '../../actions/StudentAction';

const RegisterForm = (props) => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const date=moment().format('YYYY-MM-DD')
    const currentYear=moment(date).format('YYYY')
    const nextYear=moment(date).format('YYYY').toString().slice(2)
    const sessionDate =`${currentYear-1}-${nextYear}`

    const [name, setName] = useState({ value: '', error: '', isRequired: true });
    const [session, setSession] = useState({ value: sessionDate, error: '', isRequired: true });
    const [country, setCountry] = useState({ value:'', error: '', options: [], isRequired: true });
    const [cities, setCities] = useState({ value:'', error:'', options: [], isRequired: false });
    const [otherCityName, setOtherCityName] = useState({ value: '', error: '', options: [], isRequired: false });
    const [mobileNumber, setMobile] = useState({ value: '', error: '', options: [], isRequired: false });
    const [gender, setGender] = useState({ value: '', error: '', options: [], isRequired: false });
    const [schools, setSchools] = useState({ name: 'schools', value: '', error: '', options: [], isRequired: true });
    const [otherSchoolName, setOtherSchoolName] = useState({ value: '', error: '', options: [], isRequired: false });
    const [isOtherSchool, setIsOtherSchool] = useState(false)
    const [classes, setClasses] = useState({ value: '', error: '', options: [], isRequired: false });
    const [courses, setCourses] = useState({ value: '', error: '', options: [], isRequired: false });
    const [countryCode, setCountryCode] = useState({ value: '', error: '', options: [], isRequired: false });
    const [studyCenter, setStudyCenter] = useState({ value: '', error: '', options: [], isRequired: false });
    const [email, setEmail] = useState({ value: '', error: '', options: [], isRequired: false });
    const [password, setPassword] = useState({ value: '', error: '', msg: '*Password must contain min 8 characters.', options: [], isRequired: false });
    const [confirmPassword, setConfirmPassword] = useState({ value: '', error: '', options: [], isRequired: false });
    const [acceptTerms, setAccetpTerms] = useState({  value:false, error: '' });
    const [isValid, setIsValid] = useState(false)
    const [isOtherCity, setOtherCity] = useState(false)
    const [countryValue,setCountryValue]=useState({})

    const utmParams=props.utmParams

    useEffect(() => {
        window.scroll(0,0)
        getCountries()
            .then((res) => {
                setCountry({ ...country, options: res.data })
            });

            getClasses()
            .then((res) => {
                setClasses({ ...classes, options: res.data })
            });

    }, [])

    const handleCountryChange = async (e) => {
        setCountry({ ...country, value: e, error: '' });

        const citiesRes=await getCities(e.id)
        setCities({ ...cities, options:citiesRes.data,value:citiesRes.data.length==1?citiesRes.data[0]:''})
        setOtherCity(false)
        setOtherCityName({...otherCityName,error:''})

        getSchools(e.id)
        .then((res) => {
            setSchools({ ...schools, options:res.data,value:res.data.length==1?res.data[0]:''})
        });

        const courseRes=await getCourses(e.id,classes.value.id,studyCenter.value.id)
        setCourses({ ...courses, options: courseRes.data,value:''})


        const countryCodeRes = await getCountryCode(e.id)
        setCountryCode({ ...countryCode, value: countryCodeRes.data.isd_code })

        const studyCenterRes = await getStudyCenter(e.id)
        setStudyCenter({ ...studyCenter, options: studyCenterRes.data,value:studyCenterRes.data.length==1?studyCenterRes.data[0]:''})
          
    }

    const handleCityChange = (e) => {

        const cVal = e.id;
        setCities({ ...cities, value:e, error: '' })
        
        setCourses({ ...courses, value:'', error: '' });
        setOtherCityName({...otherCityName,value:'',error:''})

        if (cVal == 0) {
            setOtherCity(true)
        }
        else {
            setOtherCity(false)
        }
    }

    const handleSchoolChange = (e) => {
        const sVal = e.id
        setSchools({ ...schools, value: e, error: '' });
        setOtherSchoolName({ ...otherSchoolName, value: '', error: '' })
        if (sVal == 0) {
            setIsOtherSchool(true)
        }
        else {
            setIsOtherSchool(false)
        }

    }

    const handleCoursesChange = (e) => {
        setCourses({ ...courses, value: e, error: '' });
    }

    const handleCountryCodeChange = (e) => {
        setCountryCode({ ...countryCode, value: e.id });
    }

    const handleClassChange = (e) => {
        setClasses({ ...classes, value: e, error: '' });

        getCourses(country.value.id,e.id,studyCenter.value.id)
        .then((res) => {
            setCourses({ ...courses, options: res.data,value:res.data?.length==1?res.data[0]:''   })
        });
    }

    const handleStudyCenterChange = (e) => {

        setStudyCenter({ ...studyCenter, value: e, error: '' });
        getCourses(country.value.id,classes.value.id,e.id)
        .then((res) => {
            setCourses({ ...courses, options:res.data,value:res.data?.length==1?res.data[0]:''  })
        });
    }


    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword({ ...confirmPassword, value: e.target.value, error: '' })
    }

    // Validations are here  
    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let regex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let formIsValid = true
      
        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }

        if (!cities.value) {
            formIsValid = false
            let msg = "Please select city"
            setCities({ ...cities, error: msg })
        }
        
        if (cities.value.id == 0) {
            formIsValid = true
            setCities({ ...cities, error: '' })
            if (!otherCityName.value) {
                formIsValid = false
                setOtherCityName({ ...otherCityName, error: 'Please provide other city name' })
            }

            if (otherCityName.value !== '' && otherCityName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherCityName({ ...otherCityName, error: msg })
            }
            else if (otherCityName.value !== '' && otherCityName.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherCityName({ ...otherCityName, error: msg })
            }
        }

        if(!schools.value){
            formIsValid = false
            let msg = "Please select school"
            setSchools({...schools,error:msg})
        }

         // School
         if (schools.value.id==0) {
            formIsValid = true
            setSchools({ ...schools, error: '' })
                if(!otherSchoolName.value){
                    formIsValid = false
                    setOtherSchoolName({...otherSchoolName,error:'Please provide other school name'})
                }

                 // Other school
            if (otherSchoolName.value !== '' && otherSchoolName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
            else if (otherSchoolName.value !== '' && otherSchoolName.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
        }

        if (!classes.value) {
            formIsValid = false
            let msg = "Please select class"
            setClasses({ ...classes, error: msg })
        }
        if (!studyCenter.value) {
            formIsValid = false
            let msg = "Please select study center"
            setStudyCenter({ ...studyCenter, error: msg })
        }
        if (!courses.value) {
            formIsValid = false
            let msg = "Please select course"
            setCourses({ ...courses, error: msg })
        }

        if (!acceptTerms.value) {
            formIsValid = false
            let msg = "Please agree to our terms & condition to continue registration."
            setAccetpTerms({ ...acceptTerms, error: msg })
        }
        // Student Name
        if (!name.value) {
            formIsValid = false
            let msg = "Please enter name"
            setName({ ...name, error: msg })
        }
        else if (name.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setName({ ...name, error: msg })
        }
        else if (name.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setName({ ...name, error: msg })
        }
        else if (!nameRegex.test(name.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setName({ ...name, error: msg })
        }

        // Email validation
        if (!email.value) {
            formIsValid = false
            let msg = "Please enter your email"
            setEmail({ ...email, error: msg })
        }

        if (email.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setEmail({ ...email, error: msg })
        }
        if (email.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setEmail({ ...email, error: msg })
        }

        if (typeof email.value !== "undefined") {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(email.value)) {
                formIsValid = false
                let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
                setEmail({ ...email, error: msg })
            }
        }


        // Phone number
        if (!mobileNumber.value) {
            formIsValid = false
            let msg = "Please enter your mobile number"
            setMobile({ ...mobileNumber, error: msg })
        }

        if(country.value.id ===1 || country.value.id ===2 || country.value.id ===4 || country.value.id ===5){
            if(mobileNumber.value.length < 8){
                formIsValid = false
                let msg = "Min 8 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
            else if(mobileNumber.value.length > 8){
                formIsValid = false
                let msg = "Max 8 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
        }
        else if(country.value.id ===6){
            if(mobileNumber.value.length < 9){
                formIsValid = false
                let msg = "Min 9 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
            else if(mobileNumber.value.length > 9){
                formIsValid = false
                let msg = "Max 9 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
        }

        else if(country.value.id ===7){
            if(mobileNumber.value.length < 9){
                formIsValid = false
                let msg = "Min 9 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
            else if(mobileNumber.value.length > 10){
                formIsValid = false
                let msg = "Max 10 Digit Length"
                setMobile({ ...mobileNumber, error: msg })
            }
        }

        if (!mobileRegex.test(mobileNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setMobile({ ...mobileNumber, error: msg })
        }

        // Passowrd
        const forbiddenChar = '&';
        const passValue = password.value

        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({ ...password, error: msg })
        }
        if (passValue.includes(forbiddenChar)) {
            formIsValid = false
            let msg = "The character & is not allowed in the password field."
            setPassword({ ...password, error: msg })
        }
        if (password.value.length <= 7) {
            formIsValid = false
            let msg = "Password must contain at least 8 characters"
            setPassword({ ...password, error: msg })
        }

        // confirm pass
        if (!confirmPassword.value) {
            formIsValid = false
            let msg = "Please confirm you password"
            setConfirmPassword({ ...confirmPassword, error: msg })
        }
        if (confirmPassword.value !== password.value) {
            formIsValid = false
            let msg = "Password is not matching"
            setConfirmPassword({ ...confirmPassword, error: msg })
        }

        // Other city name
        if (otherCityName.value !== '' && otherCityName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setOtherCityName({ ...otherCityName, error: msg })
        }
        else if (otherCityName.value !== '' && otherCityName.value.length >= 50) {
            formIsValid = false
            let msg = "Max 50 Character Length"
            setOtherCityName({ ...otherCityName, error: msg })
        }

        if (formIsValid) {
            setName({ ...name, error: '' });
            setEmail({ ...email, error: '' })
            setMobile({ ...mobileNumber, error: '' })
            setCities({ ...cities, error: '' })
            setSchools({ ...schools, error: '' })
            setClasses({ ...classes, error: '' })
            setStudyCenter({ ...studyCenter, error: '' })
            setCourses({ ...courses, error: '' })
            setPassword({ ...password, error: '' })
            setConfirmPassword({ ...confirmPassword, error: '' })
            setAccetpTerms({ ...acceptTerms, error: '' })
            setOtherCityName({ ...otherCityName, error: '' })
            setOtherSchoolName({ ...otherSchoolName, error: '' })
        }
        setIsValid(formIsValid)
        return formIsValid;

    }
    const onSubmit = (e) => {
        e.preventDefault();
        if (validation()) {
            let data = {
                name: name.value,
                city_id: cities.value.id,
                country_id: country.value.id,
                email: email.value,
                mobile_no: mobileNumber.value,
                school_id: schools.value.id,
                center_id: studyCenter.value.id,
                class_id: classes.value.id,
                password: password.value,
                course_id: courses.value.id,
                country_code: countryCode.value,
                device_type: "Web",
                device_id: "hdfgsjhd8784##%^$%",
                device_token: "",
                other_city: otherCityName.value ? otherCityName.value : '',
                other_school: otherSchoolName.value ? otherSchoolName.value : '',
                session: session.value
            }

            // if(utmParams!==null){
            //     data=Object.assign(data,utmParams)
            // }

            // console.log('utm parameters...',utmParams !==undefined && utmParams)
            let utmData;
            registerUser(data).then(res => {
                let registerDataContain = res.data
                // let registerForm_num = registerDataContain?.form_num
                let formNumData ={
                    form_num : registerDataContain?.form_num
                }
                
                if(utmParams!==null){
                    utmData=Object.assign(formNumData,utmParams)
                }
                if (res.status) {
                    salesforceSendFormNumber(utmData).then((res) => {
                        console.log('salesforce res...',res)
                    })

                    setIsValid(false)
                    swal('You are successfully registered', '', 'success')
                    navigate('/dashboard');

                }
                else {
                    let msg = res.message ? res.message : 'Something went wrong'
                    swal(msg, '', 'error')
                    setIsValid(false)
                }
            })
            .catch(err => {
                console.log(err);
            })
        }
    }


    return (
        <>
        <form onSubmit={onSubmit} autoComplete="false" className="hold_mandatoryField">
            <div className='row mb-3'>
                <div className='col-md-6'><h4>Personal Info :</h4></div>
                <div className='col-md-12 text-start text-muted'><span className='invalidFeedback'>Indicates required fields</span></div>
            </div>

            <div className='row'>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <Select
                            className='search-select-dropdown'
                            name="country"
                            value={country.value}
                            placeholder="Select Country..."
                            options={country.options}
                            onChange={handleCountryChange}
                            getOptionLabel={x => x.name}
                            getOptionValue={x => x.id}
                        />
                    </div>
                    {country.error.length > 0 && <div className='invalidFeedback'>{country.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                    <div className="form-floating diff_disable">
                        <input
                            type="text"
                            className="form-control"
                            name="session"
                            disabled
                            placeholder="Session"
                            value={session.value}
                            // onChange={(e) => setSession({ ...session, value: e.target.value, error: '' })}
                        />
                        <label>Session</label>
                    </div>
                    {/* {session.error.length > 0 && <div className='invalidFeedback'>{country.error}</div>} */}
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Student's Full Name"
                            value={name.value}
                            onChange={(e) => setName({ ...name, value: e.target.value, error: '' })}
                        />
                        <label>Student's Full Name</label>
                    </div>
                    {name.error.length > 0 && <div className='invalidFeedback'>{name.error}</div>}
                </div>
                
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            name="email"
                            placeholder="Email"
                            value={email.value}
                            onChange={(e) => setEmail({ ...email, value: e.target.value, error: '' })}
                            autoComplete="false"
                        />
                        <label>Email Address</label>
                    </div>
                    {email.error.length > 0 && <div className='invalidFeedback'>{email.error}</div>}
                </div>
                {/* Country code */}
                <div className="col-lg-6  mb-3">
                    <div className='d-flex'>
                        <div className="form-floating d-inline">
                            <input
                                type="text"
                                className="form-control rounded-start rounded-0 px-2"
                                name="countryCode"
                                readOnly
                                placeholder="Country code"
                                value={countryCode.value}
                                onChange={(e) => setCountryCode({ ...countryCode, value: e.target.value })}
                            />
                            <label className='px-2 optional'><small>Country Code</small></label>
                        </div>
                        <div className="form-floating w-100 d-inline">
                            <input
                                type="text" className="form-control rounded-end rounded-0" name="mobileNumber"
                                placeholder="Mobile number" value={mobileNumber.value==null?'':mobileNumber.value}
                                onKeyDown={ e => ( e.keyCode === 69 || e.keyCode === 190 ) && e.preventDefault()}
                                onKeyPress={e => e.target.value.length ==4 && false}
                                onChange={(e) =>{
                                    let value = e.target.value
                                    value = value.replace(/\D/g, '')   
                                    setMobile({ ...mobileNumber, value: value, error: '' })
                                }
                                }
                            />
                            <label>Mobile No</label>
                        </div>
                    </div>

                    {mobileNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{mobileNumber.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                    <Select
                        className='search-select-dropdown'
                        name="cities"
                        value={cities.value}
                        placeholder={`${country.value.id &&country.value.id === countryId.UAE  ? "Select Emirates..." :'Select City...'}`}
                        options={cities.options}
                        onChange={handleCityChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                    />
                    {cities.error.length > 0 && <div className='invalidFeedback'>{cities.error}</div>}
                </div>


                <div className="col-lg-12 mb-3">
                    <div className="form-floating diff_disable">
                        <input
                            type="text"
                            className="form-control"
                            name="otherCityName"
                            disabled={!isOtherCity}
                            placeholder={`${country.value.id &&country.value.id === countryId.UAE  ? "Other Emirates Name..." :'Other City Name...'}`}
                            value={otherCityName.value}
                            onChange={(e) => setOtherCityName({ ...otherCityName, value: e.target.value, error: '' })}
                        />
                        <label className={!isOtherCity ? 'optional':''}>{country.value.id &&country.value.id === countryId.UAE  ? "Other Emirates Name..." :'Other City Name...'}</label>
                    </div>
                    {otherCityName.error.length > 0 && <div className='invalidFeedback'>{otherCityName.error}</div>}
                </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floatings">
                                    <label className="mb-2 text-muted">School</label>
                                    <Select
                                        className='search-select-dropdown'
                                        name="schools"
                                        value={schools.value!==null?schools.value:''}
                                        placeholder='Select school'
                                        options={schools.options}
                                        onChange={handleSchoolChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                    />
                                </div>
                                {schools.error.length > 0 && <div className='invalidFeedback'>{schools.error}</div>}
                            </div>
                            
                            <div className="col-lg-6 mt-4 pt-2 mb-3">
                                <div className="form-floating diff_disable">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="otherSchoolName"
                                        placeholder="Other School Name"
                                        value={otherSchoolName.value!==null?otherSchoolName.value:'' }
                                        disabled={!isOtherSchool}
                                        onChange={(e) => setOtherSchoolName({ ...otherSchoolName, value: e.target.value, error: '' })}
                                    />
                                    <label className={!isOtherSchool ? 'optional':''}>Other School Name</label>
                                </div>
                                {otherSchoolName.error.length > 0 && <div className='invalidFeedback'>{otherSchoolName.error}</div>}
                            </div>

                 

            </div>

            <h4 className="mb-4">Course Details</h4>
            <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <Select
                        className='search-select-dropdown'
                        name="classes"
                        value={classes.value}
                        placeholder='Select Classes...'
                        options={classes.options}
                        onChange={handleClassChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                    />

                    </div>
                    {classes.error.length > 0 && <div className='invalidFeedback'>{classes.error}</div>}

                </div>

                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <Select
                        className='search-select-dropdown'
                        name="studyCenter"
                        value={studyCenter.value}
                        placeholder='Select Study Center...'
                        options={studyCenter.options}
                        onChange={handleStudyCenterChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                        />
                    </div>
                    {studyCenter.error !== undefined && studyCenter.error.length > 0 && <div className='invalidFeedback'>{studyCenter.error}</div>}

                </div>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">

                        <Select
                        className='search-select-dropdown'
                        name="courses"
                        value={courses.value}
                        placeholder='Select Course...'
                        options={courses.options}
                        onChange={handleCoursesChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                        />
                    </div>
                    {courses.error.length > 0 && <div className='invalidFeedback'>{courses.error}</div>}

                </div>

               
            </div>

           
            <h4 className="mb-4">Create a password for your profile</h4>
            <div className="row">

                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Email"
                            value={password.value}
                            onChange={(e) => setPassword({ ...password, value: e.target.value, error: '' })}
                            autoComplete="false"
                        />
                        <i className="fas fa-eye-slash toggle-password"></i>
                        <label>Create a New Password</label>
                    </div>
                    {password.error.length > 0 ? <div className='invalidFeedback'>{password.error}</div> :
                        <span className='text-muted'>{password.msg}</span>}

                </div>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating pass_word">
                        <input
                            type="password"
                            className="form-control"
                            name="confirmPassword"
                            placeholder="Email"
                            value={confirmPassword.value}
                            onChange={handleConfirmPasswordChange}
                            autoComplete="false"
                        />
                        <i className="fas fa-eye-slash toggle-password"></i>
                        <label>Confirm Password</label>
                    </div>
                    {confirmPassword.error.length > 0 && <div className='invalidFeedback'>{confirmPassword.error}</div>}
                </div>

                <div className="col-lg-12 mb-3 position-relative checkbox">
                    <div className="form-check ps-0 mandotory_field">
                        <input type="checkbox" name="acceptTerms" value={acceptTerms.value} id="termsCheck" onChange={(e) => setAccetpTerms({ ...acceptTerms, value: e.target.value, error: '' })} />
                        <label className="form-check-label terms_check d-inline" htmlFor="termsCheck">
                            &nbsp; I hereby confirm that I have read all <a href='https://www.allenoverseas.com/terms-and-conditions.aspx' target='_blank' ><strong>Terms & Conditions</strong></a> related to ALLEN
                            Overseas Program
                        </label>
                    </div>
                    {acceptTerms.error.length > 0 && <div className='invalidFeedback'>{acceptTerms.error}</div>}

                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                    {isValid ? (<button type="submit" disabled className="btn btn-primary btn-lg register_btn">
                        <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                        Processing ...</button>) :
                        <button type="submit" className="btn btn-primary btn-lg register_btn" >Register</button>
                    }
                </div>
                <div className="col-lg-12 text-center">
                    <p className="mb-0">Already have an account? <Link to="/login">Login Here</Link></p>
                </div>

            </div>
        </form>

        </>
    )


}

export default RegisterForm
